<template>
    <DModal
        :show="showModal"
        overflow-auto
        :title="__('tools.php_eol.batches.exclude_subscription_domains_form.title')"
        :message="__('tools.php_eol.batches.exclude_subscription_domains_form.message')"
        @close="$emit('close-modal')"
        @confirm="submitForm"
    >
        <template #default>
            <DCard
                padding
                class="min-height"
            >
                <div class="d-flex justify-content-between align-items-center gap-3 p-1 header-section">
                    <span class="required">{{ __('tools.php_eol.batches.exclude_subscription_domains_form.excluded_subscription_domains') }}</span>
                </div>
                <div
                    v-for="(item, index) in form.excluded_subscription_domains"
                    :key="index"
                >
                    <div class="d-flex justify-content-between align-items-center gap-2 p-1">
                        <DInput
                            :id="`excluded_subscription_domain_${index}`"
                            v-model="item.domain"
                            :placeholder="__('tools.php_eol.batches.exclude_subscription_domains_form.domain_placeholder')"
                            :is-valid="isFormFieldValid(`excluded_subscription_domain_${index}.domain`)"
                            maxlength="255"
                        />
                        <DButton
                            :id="`excluded_subscription_domain_delete_${index}`"
                            icon="trash-can-outline"
                            color="danger"
                            mini
                            @click="deleteRow(item)"
                        />
                    </div>
                    <div
                        v-if="errorsData[`excluded_subscription_domains.${index}.domain`]"
                        class="text-danger ms-2"
                    >
                        {{ errorsData[`excluded_subscription_domains.${index}.domain`] }}
                    </div>
                </div>
            </DCard>
        </template>
        <template #actions>
            <DButton
                id="add_new_domain_row"
                mini
                color="success"
                icon="plus"
                :label="__('tools.php_eol.batches.exclude_subscription_domains_form.add_row_button')"
                @click="addSubscriptionDomain()"
            />
        </template>
    </DModal>
</template>

<script setup>

import { useForm } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'
import { ref } from 'vue'

const props = defineProps({
    errors: {
        type: Object,
        default: () => { return {} }
    },
    showModal: {
        type: Boolean,
        default: false
    },
    excludedSubscriptionDomains: {
        type: Array,
        default () {
            return []
        }
    },
    activeModule: {
        type: String,
        default () {
            return ''
        }
    }
})

const errorsData = ref(props.errors)

const form = useForm({
    excluded_subscription_domains: props.excludedSubscriptionDomains ?? [],
    module: props.activeModule
})

const emit = defineEmits(['close-modal', 'form-submitted'])

function addSubscriptionDomain () {
    const newEmptyRow = getNewRow()
    form.excluded_subscription_domains.push(newEmptyRow)
}

function getNewRow () {
    return {
        domain: null,
    }
}

function deleteRow (item) {
    form.excluded_subscription_domains.splice(form.excluded_subscription_domains.indexOf(item), 1)
}

const submitForm = () => {
    form.post(route('contracts.php-eol-exclude-domains.store'), {
        onSuccess: () => {
            errorsData.value = {}
            emit('close-modal')
        },
        onError: (error) => {
            errorsData.value = error
        }
    })
}
</script>

<style scoped lang="scss">
:deep(.modal-box) {
        max-height: none !important;
}
.min-height {
    min-height: 400px;
}
</style>
